import { useEffect } from 'react';
import { X, Flame, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface NotificationToastProps {
    notification: {
        id: string;
        message: string;
        data?: any;
    };
    onDismiss: () => void;
}

export default function NotificationToast({ notification, onDismiss }: NotificationToastProps) {
    const navigate = useNavigate();

    // Auto-dismiss after 10 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            onDismiss();
        }, 10000);
        return () => clearTimeout(timer);
    }, [onDismiss]);

    const handleJoin = () => {
        // Navigate to New Session with pre-filled state
        navigate('/logs/new', {
            state: {
                cloneSession: notification.data
            }
        });
        onDismiss();
    };

    return (
        <div className="w-80 bg-dark-bg/95 backdrop-blur-xl border border-accent-purple/50 rounded-2xl shadow-2xl overflow-hidden p-4 relative group">
            {/* Gradient Glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-accent-purple/10 to-transparent opacity-50 pointer-events-none" />

            <div className="relative z-10">
                <div className="flex justify-between items-start mb-2">
                    <div className="flex items-center gap-2 text-accent-purple">
                        <Flame size={18} className="animate-pulse" />
                        <span className="text-[10px] font-black uppercase tracking-widest">Partner Activity</span>
                    </div>
                    <button
                        onClick={(e) => { e.stopPropagation(); onDismiss(); }}
                        className="text-dark-muted hover:text-white transition-colors"
                    >
                        <X size={14} />
                    </button>
                </div>

                <p className="text-sm font-bold text-white leading-tight mb-3">
                    {notification.message}
                </p>

                <button
                    onClick={handleJoin}
                    className="w-full py-2 bg-accent-purple text-white rounded-xl text-xs font-black uppercase tracking-widest hover:bg-accent-purple-light transition-all flex items-center justify-center gap-2 group/btn"
                >
                    <Users size={14} />
                    Join Session
                    <ArrowRight size={14} className="group-hover/btn:translate-x-1 transition-transform" />
                </button>
            </div>

            {/* Progress Bar for Auto-dismiss */}
            <div className="absolute bottom-0 left-0 h-1 bg-accent-purple/30 w-full">
                <div className="h-full bg-accent-purple origin-left animate-[shrink_10s_linear_forwards]" />
            </div>
        </div>
    );
}
